<template>
<v-app>
  <v-main>
    <v-container fluid>
  <v-flex xs12 sm4 offset-sm4>
  <v-form v-model="valid" ref="form" lazy-validation>
  <v-card >
        <v-toolbar flat dense>
          <v-toolbar-title>Change password</v-toolbar-title>
        </v-toolbar>
        <v-container grid-list-sm class="pa-4">

          <v-layout row wrap>
             <v-flex xs12>
            <v-text-field
                prepend-icon="person"
                label="E-mail"
                v-model="email"
                :rules="emailRules"
                required
            ></v-text-field>

            </v-flex>

            <v-flex xs12>
                          <v-text-field
                              type="password"
                              prepend-icon="lock"
                              label="Old Password"
                              v-model="oldpassword"
                              :rules="passwordRules"
                              required
                          ></v-text-field>

            </v-flex>
            <v-flex xs12>
                          <v-text-field
                              type="password"
                              prepend-icon="lock"
                              label="New Password"
                              v-model="newpassword"
                              :rules="passwordRules"
                              required
                          ></v-text-field>

            </v-flex>
          </v-layout>

        </v-container>
        <v-card-actions>

          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="clear">Cancel</v-btn>
          <v-btn text @click="changePass" :disabled="!valid">Submit</v-btn>

        </v-card-actions>
      </v-card>
  </v-form> 
  </v-flex>

    </v-container>
  </v-main>
  <v-footer app></v-footer>
</v-app>
</template>

<script>
import Auth from '../core/auth';
export default {
  data: () => ({
    valid: true,
    email: '',
    emailRules: [
      v => !!v || 'E-mail is required',
      v =>
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        'E-mail must be valid'
    ],
    oldpassword: '',
    newpassword: '',
    passwordRules: [v => !!v || 'Password is required'],
    checkbox: false
  }),
  methods: {
    clear () {
      this.$refs.form.reset();
    },
    changePass () {
      var app = this;
      if (this.$refs.form.validate()) {
        console.log('changePass driver id', this.user.id)
        Auth.changepass(app, {
          id: this.user.id,
          email: this.email,
          oldpassword: this.oldpassword,
          newpassword: this.newpassword
        });
      }
    }
  },
  computed: {
    user: Auth.getUser
  }
};
</script>

<style lang="scss">

</style>



